export default "__VITE_ASSET__DpTkHx1y__"